import { render, staticRenderFns } from "./DetectFlightsDialog.vue?vue&type=template&id=a4b78aaa&scoped=true&"
import script from "./DetectFlightsDialog.vue?vue&type=script&lang=js&"
export * from "./DetectFlightsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4b78aaa",
  null
  
)

export default component.exports